'use client';

import WebsiteSettingsContextProvider from 'context/WebsiteSettingsContext';

const ReactWebsiteSettingsProvider = ({ children }) => {
  return <WebsiteSettingsContextProvider>{children}</WebsiteSettingsContextProvider>;
}

export default ReactWebsiteSettingsProvider;
